import axios from "axios";
import { IResponse } from "features/common/hooks/useRequest";
import { AnaliseCritica } from "features/projetos/models/AnaliseCritica";

export async function fetchAnaliseCritica(analiseId: string): Promise<IResponse<AnaliseCritica>> {
    return await axios.get(`/AnaliseCritica/${analiseId}`);
}
